import { Assignment } from '@insync-students-lib/models';

/**
 * Serializes an Assignment, use only on component, not in API calls
 */
export function serializeAssignment(data): Assignment {
  return new Assignment({
    assignedAt: data.assignedAt,
    contentId: data.contentId,
    contextId: data.contextId,
    dueDate: data.dueDate,
    evidenceType: data.evidenceType,
    id: data.id,
    instructions: data.instructions,
    resourceId: data.resourceId,
    status: data.status,
    title: data.title,
    userAssignmentId: data.userAssignmentId,
    userStatus: data.userStatus,
    parentId: data.parentId,
    parentType: data.parentType
  });
}